module.exports = __webpack_public_path__ + "img/icon-kind-other.2980fc34.svg";